import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { useNavigate, useParams, Link, useSearchParams } from "react-router-dom";
import GoogleMapComponent from "./../../components/GoogleMapComponent";
import { useAuth } from "../../context/AuthContext";
import { storage, ID, Permission, Role } from "../../appwrite/config";
import AlertMessage from "../include/AlertMessage";
var _ = require('lodash');

function EditShop() {

    const [searchParams] = useSearchParams();
    const page = searchParams.get("page") || 1;

    const [alert, setAlert] = useState({ type: "", message: "" });
    const [formData, setformData] = useState({
        userid: '',
        categoryid: '',
        name: '',
        latitude: '',
        longitude: '',
        phone: '',
        description: '',
        isActive: false,
        imageID: [] // 🔥 existing images
    });
    const [files, setFiles] = useState([]); // 🔥 new images
    const [previewUrls, setPreviewUrls] = useState([]);
    const [images, setImages] = useState([]);
    const [deletedImageIds, setDeletedImageIds] = useState([]);

    const [errors, setErrors] = useState({});
    const [allCategories, setAllCategories] = useState([]);
    const [allUsers, setAllUsers] = useState([]);

    const { id } = useParams();
    const { role, user } = useAuth();
    const redirectHistory = useNavigate();
    const token = sessionStorage.getItem('JWT_TOKEN');

    const [markerPosition, setMarkerPosition] = useState(null);
    const [latitude, setLatitude] = useState({});
    const [longitude, setLongitude] = useState({});
    const [loading, setLoading] = useState(true);



    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Name is required.";
        if (!formData.latitude) newErrors.latitude = "Latitude is required.";
        if (!formData.longitude) newErrors.longitude = "Longitude is required.";
        if (formData.phone) {
            const phone = formData.phone.trim();

            // Must start with +
            if (!phone.startsWith("+")) {
                newErrors.phone = "Phone number must start with '+'";
            }
            // Only + followed by digits
            else if (!/^\+\d+$/.test(phone)) {
                newErrors.phone = "Only digits are allowed after '+'";
            }
            // Length validation (8-15 digits)
            else {
                const digits = phone.substring(1); // remove +

                if (digits.length < 8 || digits.length > 15) {
                    newErrors.phone =
                        "Phone number must contain 8 to 15 digits";
                }
            }
        }
        if (!formData.description) newErrors.description = "Description is required.";
        return newErrors;
    };

    // Define an async function inside useEffect
    const fetchShopDetail = async () => {
        try {

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/fetchShopDetail/${id}`, {
                headers: {
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });


            const resdata = response.data.data;
            // 🔥 UPDATED: structured images
            let imgs = [];
            if (Array.isArray(resdata.imageID)) {
                imgs = resdata.imageID.map(imgId => ({
                    url: storage.getFilePreview(process.env.REACT_APP_BUCKET_ID, imgId).toString(),
                    id: imgId,
                    isNew: false
                }));
            }
            setImages(imgs);

            // setPreviewUrls(previews);

            const customdata = {
                userid: resdata.user || '',
                categoryid: resdata.category,
                imageID: resdata.imageID || [],
                name: resdata.name,
                latitude: resdata.latitude,
                longitude: resdata.longitude,
                phone: resdata.phone || '',
                description: resdata.description,
                isActive: resdata.isActive
            }
            setformData(customdata); // Set data to state            
            setMarkerPosition({
                lat: customdata.latitude,
                lng: customdata.longitude,
            });

            //setIsToggled(resdata.isActive);
        } catch (error) {
            const apierror = _.get(error, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        }

    };

    useEffect(() => {
        document.documentElement.className = "";
        if (role === "business" && user?.$id) {
            setformData(prev => ({
                ...prev,
                userid: user.$id
            }));
        }

        fetchAllCategories();
        fetchAllUsers();

        fetchShopDetail();
    }, [id]);


    const handleChange = (e) => {
        setformData({ ...formData, [e.target.name]: (e.target.type === 'checkbox') ? e.target.checked : e.target.value });
    };

    const handleFileChange = async (e) => {
        e.preventDefault();

        const selectedFiles = Array.from(e.target.files);
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
        const maxSize = 5 * 1024 * 1024; // ✅ 2MB

        let validFiles = [];
        let invalidFiles = [];

        selectedFiles.forEach(file => {

            // ❌ Type validation
            if (!allowedTypes.includes(file.type)) {
                invalidFiles.push(file.name + " (invalid type)");
                return;
            }

            // ❌ Size validation
            if (file.size > maxSize) {
                invalidFiles.push(file.name + " (too large)");
                return;
            }

            // ✅ Valid file
            validFiles.push(file);
        });

        // ❌ Show error if any invalid files
        if (invalidFiles.length > 0) {
            setAlert({
                type: "error",
                message: `Some files are invalid: ${invalidFiles.join(", ")}`
            });
        }

        // ✅ Add only valid images
        const newImages = validFiles.map(file => ({
            url: URL.createObjectURL(file),
            file: file,
            isNew: true
        }));

        setImages(prev => [...prev, ...newImages]);
    };

    // 🆕 DELETE IMAGE (both preview + existing imageID)
    const handleRemoveImage = async (index) => {
        const imageToDelete = images[index];

        const confirmDelete = window.confirm("Are you sure you want to delete this image?");
        if (!confirmDelete) return;

        try {
            // delete from Appwrite if old
            if (!imageToDelete.isNew && imageToDelete.id) {
                setDeletedImageIds(prev => [...prev, imageToDelete.id]);
            }

            const updatedImages = images.filter((_, i) => i !== index);
            setImages(updatedImages);

            // update formData image IDs
            const remainingIds = updatedImages
                .filter(img => !img.isNew)
                .map(img => img.id);

            setformData(prev => ({
                ...prev,
                imageID: remainingIds
            }));


        } catch (err) {
            console.error(err);
            setAlert({ type: "error", message: "Failed to delete image" });
        }
    };

    const handleLocationSelect = ({ lat, lng }) => {
        setformData({
            ...formData,
            latitude: lat,
            longitude: lng,
        });
    };

    const handleEdit = async (e) => {
        e.preventDefault();

        const newErrors = validate();
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            setLoading(true);
            try {

                for (let id of deletedImageIds) {
                    await storage.deleteFile(process.env.REACT_APP_BUCKET_ID, id);
                }

                const uploadPromises = images
                    .filter(img => img.isNew && img.file)
                    .map(img =>
                        storage.createFile(
                            process.env.REACT_APP_BUCKET_ID,
                            ID.unique(),
                            img.file,
                            [
                                Permission.read(Role.any()),
                                Permission.write(Role.any()) // 🔥 FIX (important)
                            ]
                        )
                    );

                const uploadedFiles = await Promise.all(uploadPromises);
                const uploadedIds = uploadedFiles.map(file => file.$id);

                // 🔥 existing images
                const existingIds = images
                    .filter(img => !img.isNew)
                    .map(img => img.id);

                const finalImageIds = [...existingIds, ...uploadedIds];

                const response = await axios.put(`${process.env.REACT_APP_API_URL}/editshop/${id}`, {
                    imageID: finalImageIds, // 🔥 IMPORTANT
                    category: formData.categoryid,
                    name: formData.name,
                    latitude: formData.latitude,
                    longitude: formData.longitude,
                    phone: formData.phone,
                    description: formData.description,
                    isActive: formData.isActive,
                    userid: formData.userid
                },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token // Replace with your token
                        }
                    }
                );

                if (response.status === 200 || response.status === 201) {
                    setAlert({ type: "success", message: "Business updated successfully." });
                    setTimeout(() => {
                        redirectHistory(`/shops?page=${page}`);
                    }, 2500);
                }

            } catch (err) {
                const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Failed to edit business. Please try again.");
                setAlert({ type: "error", message: apierror });
            } finally {
                setLoading(false);
            }
        }
    };

    const fetchAllCategories = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listallcategory`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });
            const categorydata = response.data?.documents || [];
            if (Array.isArray(categorydata) && categorydata.length > 0) {
                setAllCategories(categorydata);
            } else {
                setAllCategories([]);
            }

            setLoading(false);
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
            setLoading(false);
        } finally {
            setLoading(false);
        }

    };

    //Get all users having the business role.
    const fetchAllUsers = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listallusers`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token // Replace with your token
                }
            });

            const data = await response.data.data;
            if (Array.isArray(data) && data.length > 0) {
                const businessUsers = data.filter(
                    user => user.labels?.includes("business")
                );

                setAllUsers(businessUsers);
            } else {
                setAllUsers([]);
            }
        } catch (err) {
            const apierror = _.get(err, ['response', 'data', 'error', 'message'], "Something went wrong");
            setAlert({ type: "error", message: apierror });
        } finally {
            setLoading(false);
        }
    };


    const defaultPosition = useMemo(() => ({
        lat: Number(formData.latitude),
        lng: Number(formData.longitude)
    }), [formData.latitude, formData.longitude]);

    return (
        <section>
            <div className="is-title-bar">
                <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
                    <ul>
                        <li><Link to="/dashboard" className='btn btn-primary'>Dashboard</Link></li>
                        <li><Link to="/shops" className='btn btn-primary'>Businesses</Link></li>
                        <li>Edit</li>
                    </ul>
                </div>
            </div>
            <div className="section main-section">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-12">
                    <div className="card">
                        <header className="card-header">
                            <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-reorder-horizontal"></i></span>
                                Edit Business
                            </p>
                        </header>
                        <div className="card-content">
                            {loading ? (
                                <div className="flex justify-center items-center py-10">
                                    <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
                                </div>

                            ) : (
                                <form onSubmit={handleEdit}>
                                    {alert.message && (
                                        <AlertMessage
                                            type={alert.type}
                                            message={alert.message}
                                            onClose={() => setAlert({ type: "", message: "" })}
                                        />
                                    )}
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">Select Category <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <div className="select">
                                                    <select name="categoryid" id="categoryid" value={formData.categoryid || ''} onChange={handleChange}>
                                                        <option value={''}>---Select---</option>
                                                        {allCategories.map(cat => (
                                                            <option key={cat.$id} value={cat.$id}>
                                                                {cat.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors.categoryid && <p className="help" style={{ color: 'red' }}>{errors.categoryid}</p>}
                                                </div>
                                            </div>
                                        </div>
                                        {["admin"].includes(role) ? (
                                            <div className="field">
                                                <label className="label">User</label>

                                                <div className="control">
                                                    <div className="select">
                                                        <select id="userid" name="userid" value={formData.userid || ''} onChange={handleChange} >
                                                            <option value="">---Select---</option>
                                                            {allUsers.map((user) => (
                                                                <option key={user.$id} value={user.$id}>
                                                                    {user.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                        ) : (
                                            <input type="hidden" name="userid" id="userid" value={formData.userid} />
                                        )}
                                    </div>
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label" htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" name="name" id="name" type="text" placeholder="Name" value={formData.name} onChange={handleChange} />
                                            </div>
                                            {errors.name && <p className="help" style={{ color: 'red' }}>{errors.name}</p>}
                                        </div>
                                        <div className="field">
                                            <label className="label">Image</label>
                                            <div className="control">
                                                <input className="input" id="simage" accept="image/*" type="file" multiple onChange={handleFileChange} />
                                            </div>
                                            {errors.simage && <p className="help" style={{ color: 'red' }}>{errors.simage}</p>}
                                        </div>
                                        {/* <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">&nbsp;</label>
                                            <div className="control">
                                                {previewUrls.map((url, i) => (
                                                    <div key={i} style={{ position: 'relative', display: 'inline-block' }}>
                                                        <img src={url} style={{ width: 100, height: 80 }} />
                                                        <button
                                                            type="button"
                                                            onClick={() => handleRemoveImage(i)}
                                                            style={{ position: 'absolute', top: 0, right: 0, backgroundColor: 'red', color: 'white', border: 'none', cursor: 'pointer' }}
                                                        >
                                                            ×
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div> */}
                                    </div>
                                    {/* 🆕 IMAGE PREVIEW CARD SECTION */}
                                    {images.length > 0 && (
                                        <div className="grid sm:gap-0 md:gap-6 md:grid-cols-1 sm:grid-cols-1 sm:mb-3">
                                            <div className="card">
                                                <header className="card-header">
                                                    <p className="card-header-title">
                                                        Image Preview
                                                    </p>
                                                </header>

                                                <div className="card-content">
                                                    <div style={{
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        gap: "15px"
                                                    }}>
                                                        {images.map((img, i) => (
                                                            <div key={i} style={{
                                                                position: "relative",
                                                                width: "120px",
                                                                height: "100px"
                                                            }}>
                                                                {/* 🆕 DELETE BUTTON */}
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleRemoveImage(i)}
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: "-8px",
                                                                        right: "-8px",
                                                                        background: "red",
                                                                        color: "#fff",
                                                                        border: "none",
                                                                        borderRadius: "50%",
                                                                        width: "22px",
                                                                        height: "22px",
                                                                        cursor: "pointer",
                                                                        fontSize: "12px",
                                                                        zIndex: 10
                                                                    }}
                                                                >
                                                                    ✕
                                                                </button>

                                                                {/* IMAGE */}
                                                                <img
                                                                    src={img.url}
                                                                    alt="preview"
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "100%",
                                                                        objectFit: "cover",
                                                                        borderRadius: "6px",
                                                                        border: "1px solid #ddd"
                                                                    }}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}


                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">Latitude <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" readOnly name="latitude" id="latitude" type="text" placeholder="Latitude" value={formData.latitude} onChange={handleChange} />
                                            </div>
                                            {errors.latitude && <p className="help" style={{ color: 'red' }}>{errors.latitude}</p>}
                                        </div>
                                        <div className="field">
                                            <label className="label">Longitude <span style={{ color: "red" }}>*</span></label>
                                            <div className="control">
                                                <input className="input" readOnly name="longitude" id="longitude" type="text" placeholder="Longitude" value={formData.longitude} onChange={handleChange} />
                                            </div>
                                            {errors.longitude && <p className="help" style={{ color: 'red' }}>{errors.longitude}</p>}
                                        </div>
                                    </div>
                                    <div className="grid sm:gap-0 md:gap-6 md:grid-cols-2 sm:grid-cols-1 sm:mb-3">
                                        <div className="field">
                                            <label className="label">Phone</label>
                                            <div className="control">
                                                <input className="input" name="phone" id="phone" type="text" placeholder="+351XXXXXXXXXX" value={formData.phone} onChange={handleChange} />
                                            </div>
                                            {errors.phone && <p className="help" style={{ color: 'red' }}>{errors.phone}</p>}
                                        </div>
                                    </div>
                                    <div className="field">
                                        <label className="label">Description <span style={{ color: "red" }}>*</span></label>
                                        <div className="control">
                                            <textarea className="textarea" name="description" id="description" placeholder="Description" value={formData.description} onChange={handleChange} ></textarea>
                                        </div>
                                        {errors.description && <p className="help" style={{ color: 'red' }}>{errors.description}</p>}
                                    </div>
                                    <div className="field spaced">
                                        <div className="control">
                                            <label className="checkbox label"><input type="checkbox" name="isActive" id="isActive" checked={formData.isActive} onChange={handleChange} />
                                                <span className="check"></span>
                                                <span className="control-label">Active</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="field">
                                        <div className="control">
                                            <GoogleMapComponent
                                                onLocationSelect={handleLocationSelect}
                                                defaultPosition={defaultPosition} // edit lat/lng
                                            />

                                            {/*<GoogleMapComponent onLocationSelect={handleLocationSelect} center={markerPosition} />
                                         <GoogleMapComponent onLocationSelect={handleLocationSelect} center={markerPosition} /> */}
                                        </div>
                                    </div>
                                    <div className="flex justify-center items-center">
                                        <div className="field grouped">
                                            <div className="control">
                                                <button type="submit" className="button green">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default EditShop;